module.exports = __webpack_public_path__ + "img/icon-notfound.e49716e.png";